import { gql } from '@apollo/client';

export default gql`
  fragment ProjectUserFragment on User {
    id
    databaseId
    firstName
    lastName
    name
    initials
    avatar
    emailAddress
    phoneNumber
    status
    profilePhoto(variants: THUMBNAIL) {
      variant
      uri
    }
  }
`;
